import styled from 'styled-components';

export const TradeStyled = styled.div`
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    position: relative;
`;

export const TradeLoadingStyled = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.3);
`;